'use client'

import dynamic from 'next/dynamic'
// Type-only import — a value import here would eagerly evaluate PdfViewer's
// pdfjs side effects on the server, defeating ssr:false and throwing during SSR.
import type { PdfViewerProps } from '@achieve/cx-pdf-viewer'

const DynamicPdfViewer = dynamic(
  () => import('@achieve/cx-pdf-viewer').then((mod) => mod.PdfViewer),
  { ssr: false }
)

export function PdfViewerClient(props: PdfViewerProps) {
  return <DynamicPdfViewer {...props} />
}
